'use client';

import type { GeneralLayout } from '@eliadmin/core/src/api/general/types/general-layout-types';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { Heading } from '@eliadmin/core/src/components/ui/heading';
import { Paragraph } from '@eliadmin/core/src/components/ui/paragraph';
import { useBreakpoint } from '@eliadmin/core/src/hooks/use-breakpoint';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import Link from '@eliadmin/core/src/components/link';
import { LuNavigation2 } from 'react-icons/lu';

export function ContactMap({
  generalLayout,
  locationURL,
}: {
  generalLayout: GeneralLayout['data'];
  locationURL: string;
}) {
  const isDesktop = useBreakpoint('sm');
  const { t } = useTranslations();

  return (
    <section className={cn('custom-section', 'pb-16 pt-8 sm:pb-20 sm:pt-10 lg:pb-24 lg:pt-12')}>
      <div
        className={cn(
          'custom-container--xxl',
          'relative flex h-[700px] items-end justify-end rounded-[20px] p-4 sm:h-auto sm:items-start sm:justify-start md:p-8 lg:p-12',
        )}
      >
        <div className="relative z-10 flex flex-col items-start justify-start gap-4 overflow-hidden rounded-[20px] bg-white p-4 sm:max-w-[469px] sm:gap-6 md:gap-8 md:p-6 lg:gap-12 lg:p-8">
          <div className="flex w-full flex-col items-start justify-start gap-4 md:gap-6">
            <Heading tag={isDesktop ? 'h3' : 'h4'} title={t('text1331')} />
            <div className="flex w-full flex-col items-start justify-start gap-2">
              <Paragraph size={isDesktop ? 'lg' : 'base'}>
                {generalLayout?.contact?.company}
              </Paragraph>
              <Paragraph size={isDesktop ? 'lg' : 'base'}>
                {generalLayout?.contact?.address}
              </Paragraph>
              <Paragraph size={isDesktop ? 'lg' : 'base'}>
                {generalLayout?.contact?.postcode} {generalLayout?.contact?.city}
              </Paragraph>
              <Paragraph size={isDesktop ? 'lg' : 'base'}>
                {generalLayout?.contact?.country?.name}
              </Paragraph>
              <Paragraph size={isDesktop ? 'lg' : 'base'}>
                <strong className="font-bold">{t('text42')}:&nbsp;</strong>
                {generalLayout?.contact?.ico}
              </Paragraph>
              <Paragraph size={isDesktop ? 'lg' : 'base'}>
                <strong className="font-bold">{t('text43')}:&nbsp;</strong>
                {generalLayout?.contact?.dic}
              </Paragraph>
              <Paragraph size={isDesktop ? 'lg' : 'base'}>
                <strong className="font-bold">{t('text44')}:&nbsp;</strong>
                {generalLayout?.contact?.ic_dph}
              </Paragraph>
            </div>
            <Paragraph size={isDesktop ? 'lg' : 'base'}>
              {generalLayout?.contact?.commercial_register}
            </Paragraph>
          </div>
          <Button asChild variant={'secondary'} className="w-full">
            <Link prefetch={false} target="_blank" href={'#'}>
              <LuNavigation2 size={18} /> {t('text1337')}
            </Link>
          </Button>
        </div>
        <iframe
          className={cn('absolute inset-0 z-0 h-full w-full', 'ea-contact-map__iframe')}
          src={locationURL}
        ></iframe>
      </div>
    </section>
  );
}
